<template>
  <div class="alert notification" :class="getNotificationClass()">
    <button
      v-if="item.dismissible"
      type="button"
      class="close"
      data-dismiss="alert"
      @click="removeItem()"
    >
      ×
    </button>
    <h4 v-if="item.title">
      {{ item.title }}
    </h4>
    <div v-html="item.content"></div>
    <button
      v-if="item.action"
      class="btn btn-default btn-sm"
      @click="invokeCallback()"
    >
      {{ item.action.label }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getNotificationClass() {
      const classes = []
      classes.push(`alert-${this.item.type}`)
      if (this.item.dismissible) {
        classes.push('alert-dismissible')
      }
      return classes.join(' ')
    },
    removeItem() {
      this.$store.dispatch('notifications/removeItem', this.item)
    },
    invokeCallback() {
      this.$store.dispatch('notifications/callbackCalled', this.item)
      this.item.action.callback()
      this.removeItem()
    },
  },
}
</script>
